import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../services/navigation.service';
import { NavController } from '@ionic/angular';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ionic/angular";
import * as i3 from "../services/navigation.service";
var StoreGuard = /** @class */ (function () {
    function StoreGuard(router, route, navController, navigationService) {
        this.router = router;
        this.route = route;
        this.navController = navController;
        this.navigationService = navigationService;
    }
    StoreGuard.prototype.canActivate = function (next, state) {
        console.log('store guard');
        if (this.navigationService.lastParams && (this.navigationService.lastParams['store'] || this.navigationService.lastParams['orders']) || this.navigationService.poping) {
            return true;
        }
        else {
            // this.navController.pop().then(data => {
            //     console.log('pop ok', data);
            // }, error => {
            //     console.log('cannot pop', error);
            var t = this.navigationService.getRootPageUrl();
            console.log('store guard', t);
            if (t) {
                // TODO: not allowed to enter target root. go to parent route?
                this.navController.setDirection('root');
                this.router.navigate([this.navigationService.getRootPageUrl()]);
            }
        }
        return false;
    };
    StoreGuard.ngInjectableDef = i0.defineInjectable({ factory: function StoreGuard_Factory() { return new StoreGuard(i0.inject(i1.Router), i0.inject(i1.ActivatedRoute), i0.inject(i2.NavController), i0.inject(i3.NavigationService)); }, token: StoreGuard, providedIn: "root" });
    return StoreGuard;
}());
export { StoreGuard };
